var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"Fixed_icon"},[_c('a',{attrs:{"target":"_blank","href":_vm.itemUrl.address}},[(_vm.itemUrl.iconUri)?_c('img',{staticClass:"onLine",attrs:{"width":"100%","src":_vm.itemUrl.iconUri,"alt":""}}):_c('img',{staticClass:"onLine",attrs:{"width":"100%","src":_vm.iconType.url,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }